var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PremiumLayout',[_c('div',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.background}),_c('div',{class:_vm.$style.main},[_c('router-view',{key:_vm.$route.path,class:_vm.$style.childView})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }